import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_GRID_AREAS, NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../constants';
/**
 * Navigation actions container
 */
export const navigationActionsContainerStyles = ({ theme }) => css `
	grid-area: ${NAVIGATION_GRID_AREAS.ACTIONS};
	display: flex;
	align-items: stretch;
	list-style: none;
	margin: 0;
	padding: 0;
	place-self: stretch stretch;
	max-width: unset;
	justify-content: end;

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		padding: 0 ${pxToRem(theme.spacing['400'])} 0 0;
	}
`;
export const NavigationActionsContainer = styled.ul `
	${navigationActionsContainerStyles}
`;
